import styled from 'styled-components'

export const LoadingContainer = styled.div`
  margin: 20px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
